// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3YXEc","paramInput":"JobSimulator_paramInput__36nFy","input":"JobSimulator_input__1VM2U"};